
import { ISiteMobileJobIndexPage } from "./jobs/ISiteMobileJobIndexPage";
import { ISiteMobilePasswordlessAuthIndexPage } from "./PasswordlessAuth/ISiteMobilePasswordlessAuthIndexPage";
import { ISiteMobileWorkflowIndexPage } from "./Workflow/ISiteMobileWorkflowIndexPage";
import { ISiteMobileAccountLoginPage } from "./Account/ISiteMobileAccountLoginPage";
import { ISiteMobileSummaryIndexPage } from "./Summary/ISiteMobileSummaryIndexPage";
import { ISiteMobileWorkOrderViewPage } from "./WorkOrder/ISiteMobileWorkOrderViewPage";
import { ISiteMobileWorkOrderRiskAssessmentPage } from "./WorkOrder/ISiteMobileWorkOrderRiskAssessmentPage";
import { ISiteMobileDocumentUploadFilePage } from "./Document/ISiteMobileDocumentUploadFilePage";
import { ISiteMobileDocumentFileViewerPage } from "./Document/ISiteMobileDocumentFileViewerPage";
import { ISiteMobileWorkOrderEditPage } from "./WorkOrder/ISiteMobileWorkOrderEditPage";
import { ISiteMobileAssetPropertySearchPage } from "./Asset/ISiteMobileAssetPropertySearchPage";
import { ISiteMobileAssetSearchPage } from "./Asset/ISiteMobileAssetSearchPage";
import { ISiteMobileRecordRecordNotesPage } from "./Record/ISiteMobileRecordRecordNotesPage";
import { ISiteMobileAssetSearchAssetPage } from "./Asset/ISiteMobileAssetSearchAssetPage";
import { ISiteMobileAssetEditAssetPage } from "./Asset/ISiteMobileAssetEditAssetPage";
import { ISiteMobileDocumentCaptureImagePage } from "./Document/ISiteMobileDocumentCaptureImagePage";
import { ISiteMobileWorkOrderPPMJobScreenPage } from "./WorkOrder/ISiteMobileWorkOrderPPMJobScreenPage";
import { ISiteMobileAssetViewAssetDetailPage } from "./Asset/ISiteMobileAssetViewAssetDetailPage";

import { ISiteMobileServiceRequestCreateSRFromAssetPage } from "./ServiceRequest/ISiteMobileServiceRequestCreateSRFromAssetPage";
import { ISiteMobileServiceRequestMyServiceRequestsPage } from "./ServiceRequest/ISiteMobileServiceRequestMyServiceRequestsPage";
import { ISiteMobileServiceRequestCreateSRPage } from "./ServiceRequest/ISiteMobileServiceRequestCreateSRPage";
import { ISiteMobileDocumentFileListPage } from "./Document/ISiteMobileDocumentFileListPage";
import { ISiteMobileWorkOrderEditMaterialPage } from "./WorkOrder/ISiteMobileWorkOrderEditMaterialPage";
import { ISiteMobileWorkOrderMaterialListPage } from "./WorkOrder/ISiteMobileWorkOrderMaterialListPage";
import { ISiteMobileQuotesSubmitQuotePage } from "./WorkOrder/ISiteMobileQuotesSubmitQuotePage";
import { ISiteMobileGhostModeIndexPage } from "./GhostMode/ISiteMobileGhostModeIndexPage";









export const InitPageClasses: any =
{
    ISiteMobileWorkflowIndexPage,
    ISiteMobileJobIndexPage,
    ISiteMobilePasswordlessAuthIndexPage,    
    ISiteMobileSummaryIndexPage,
    ISiteMobileAccountLoginPage,
    ISiteMobileWorkOrderViewPage,
    ISiteMobileWorkOrderEditPage,
    ISiteMobileWorkOrderRiskAssessmentPage,
    ISiteMobileDocumentUploadFilePage,
    ISiteMobileDocumentFileViewerPage,
    ISiteMobileAssetPropertySearchPage,
    ISiteMobileAssetSearchPage,
    ISiteMobileRecordRecordNotesPage,
    ISiteMobileAssetSearchAssetPage,
    ISiteMobileAssetEditAssetPage,
    ISiteMobileDocumentCaptureImagePage,
    ISiteMobileWorkOrderPPMJobScreenPage,
    ISiteMobileServiceRequestCreateSRFromAssetPage,
    ISiteMobileServiceRequestMyServiceRequestsPage,
    ISiteMobileDocumentFileListPage,
    ISiteMobileAssetViewAssetDetailPage,
    ISiteMobileWorkOrderEditMaterialPage,
    ISiteMobileWorkOrderMaterialListPage,
    ISiteMobileQuotesSubmitQuotePage,
    ISiteMobileGhostModeIndexPage,
    ISiteMobileServiceRequestCreateSRPage
};
